import {
  useShippingCostsFilterQuery,
  UseShippingCostsFilterQueryParams,
} from "../queries/useShippingCostsFilterQuery";
import { IPagination } from "../../../interfaces/IPagination";
import { ShippingCost } from "../../../interfaces/shippingCostType";

type Response = {
  shippingCosts: ShippingCost[];
  paginationData?: IPagination;
  isLoading: boolean;
};

export const useShippingCostsFilter = (
  opt: UseShippingCostsFilterQueryParams,
): Response => {
  const { data, isLoading } = useShippingCostsFilterQuery(opt);
  return {
    shippingCosts: data?.data?.shippingCosts || [],
    paginationData: data?.data?.pagination,
    isLoading,
  };
};
